<div class="orders-page">
    <div class="page-header">
        <h3>{{ 'getorders.title' | translate }}</h3>
    </div>

    <div class="filter-panel">
        <div class="filter-grid">
            <div class="filter-field">
                <label>{{ 'getorders.filter.orderReferenceLabel' | translate }}</label>
                <input [placeholder]="'getorders.filter.orderReferencePlaceholder' | translate" type="search"
                    [(ngModel)]="orderReferenceModel" />
            </div>
            <div class="filter-field">
                <label>{{ 'getorders.filter.nameLabel' | translate }}</label>
                <input [placeholder]="'getorders.filter.namePlaceholder' | translate" type="search"
                    [(ngModel)]="filterElement.name" />
            </div>
            <div class="filter-field">
                <label>{{ 'getorders.filter.orderStatusLabel' | translate }}</label>
                <select [(ngModel)]="filterElement.orderStatus">
                    @for (statusOption of ordersAccordingToStatuses; track statusOption) {
                    <option [value]="statusOption">{{ 'admin.' + statusOption | translate }}</option>
                    }
                </select>
            </div>
            <div class="filter-field">
                <label>{{ 'getorders.filter.deliveryOptionLabel' | translate }}</label>
                <select [(ngModel)]="filterElement.deliveryOption">
                    @for (deliveryOption of ordersAccordingTodeliveryOptions; track deliveryOption) {
                    <option [value]="deliveryOption">{{ 'admin.' + deliveryOption | translate }}</option>
                    }
                </select>
            </div>
            <div class="filter-field">
                <label>{{ 'getorders.filter.orderDateLabel' | translate }}</label>
                <div class="date-toggle" role="button" tabindex="0" [attr.aria-expanded]="settingupdates"
                    [attr.aria-label]="'getorders.filter.datePicker' | translate" (click)="setDates()"
                    (keydown.enter)="setDates()" (keydown.space)="setDates()">
                    <span>{{ 'getorders.filter.datePicker' | translate }}</span>
                    <mat-icon>keyboard_arrow_down</mat-icon>
                </div>
                @if (settingupdates) {
                <div class="date-inputs">
                    <input #startDateElementInput [title]="'getorders.filter.startDate' | translate" type="date"
                        [(ngModel)]="filterElement.startDate" />
                    <input #endDateElementInput [title]="'getorders.filter.endDate' | translate" type="date"
                        [(ngModel)]="filterElement.endDate" />
                </div>
                }
            </div>
            <div class="filter-field">
                <label>{{ 'getorders.modifiedDate.label' | translate }}</label>
                <div class="date-toggle" role="button" tabindex="0" [attr.aria-expanded]="settingModifiedDates"
                    [attr.aria-label]="'getorders.modifiedDate.ariaLabel' | translate" (click)="setModifiedDates()"
                    (keydown.enter)="setModifiedDates()" (keydown.space)="setModifiedDates()">
                    <span>{{ 'getorders.modifiedDate.picker' | translate }}</span>
                    <mat-icon>keyboard_arrow_down</mat-icon>
                </div>
                @if (settingModifiedDates) {
                <div class="date-inputs">
                    <input [title]="'getorders.modifiedDate.startTitle' | translate" type="date"
                        [(ngModel)]="filterElement.modifiedStartDate" />
                    <input [title]="'getorders.modifiedDate.endTitle' | translate" type="date"
                        [(ngModel)]="filterElement.modifiedEndDate" />
                </div>
                }
            </div>
            <div class="filter-field">
                <label>{{ 'getorders.filter.productLabel' | translate }}</label>
                <select [(ngModel)]="filterElement.productId">
                    <option value="0">{{ 'getorders.filter.allProducts' | translate }}</option>
                    @for (product of products; track product) {
                    <option [value]="product.id">{{ product.author + ' ' + product.title }}</option>
                    }
                </select>
            </div>
            <div class="filter-field">
                <label>{{ 'getorders.filter.paymentStatusLabel' | translate }}</label>
                <select [(ngModel)]="filterElement.clerkPaymentStatus">
                    @for (paymentStatus of ordersAccordingToPaymentStatus; track paymentStatus) {
                    <option [value]="paymentStatus">{{ 'admin.' + paymentStatus | translate }}</option>
                    }
                </select>
            </div>
            <div class="filter-field filter-field--checkbox">
                <label>{{ 'getorders.filter.archiveLabel' | translate }}</label>
                <input type="checkbox" [(ngModel)]="filterElement.isArchivedSearch" (click)="toggleArchiveSearch()" />
            </div>
        </div>
        <div class="filter-actions">
            <button type="button" class="btn-action btn-search" (click)="filter()">
                <mat-icon>search</mat-icon>
                <span>{{ 'admin.search' | translate }}</span>
            </button>
            <button type="button" class="btn-action btn-export" (click)="exportToExcel(true)">
                <mat-icon>file_download</mat-icon>
                <span>{{ 'getorders.filter.exportActive' | translate }}</span>
            </button>
            <button type="button" class="btn-action btn-export" (click)="exportToExcel(false)">
                <mat-icon>file_download</mat-icon>
                <span>{{ 'getorders.filter.exportArchive' | translate }}</span>
            </button>
            <button type="button" class="btn-action btn-refresh" (click)="refreshPage()">
                <mat-icon>refresh</mat-icon>
                <span>{{ 'getorders.filter.settingBackFilters' | translate }}</span>
            </button>
        </div>
    </div>

    <div class="summary-bar">
        <div class="summary-info">
            <span class="summary-badge">{{ 'getorders.summary.foundCount' | translate }}{{ filteredOrder.length
                }}</span>
        </div>
    </div>

    <div class="orders-table">
        <div class="table-header">
            <div class="col col-date">{{ 'getorders.table.date' | translate }}</div>
            <div class="col col-ref">{{ 'getorders.table.orderReference' | translate }}</div>
            <div class="col col-name">{{ 'getorders.table.name' | translate }}</div>
            <div class="col col-email">{{ 'getorders.table.email' | translate }}</div>
            <div class="col col-preorder">{{ 'getorders.table.preorder' | translate }}</div>
            <div class="col col-price">{{ 'getorders.table.totalPrice' | translate }}</div>
            <div class="col col-payment">{{ 'getorders.table.paymentStatus' | translate }}</div>
            <div class="col col-invoice">{{ 'getorders.table.invoice' | translate }}</div>
            <div class="col col-expand"></div>
        </div>

        @for (order of filteredOrder; track order.orderReference; let i = $index) {
        <div class="table-row" [class.expanded]="expandedOrderReference === order.orderReference"
            [class.table-row--unopened]="!order.clerkOpened" (click)="toggleOrderDetails(order)">
            <div class="col col-date">{{ order.orderDate | dateUtil }}</div>
            <div class="col col-ref">
                <button type="button" class="btn-ref" id="{{ order.orderReference! }}"
                    [attr.aria-label]="('getorders.orderDetailsAriaPrefix' | translate) + ' ' + order.orderReference">
                    {{ order.orderReference }}
                </button>
            </div>
            <div class="col col-name">{{ order.name }}</div>
            <div class="col col-email">{{ order.email }}</div>
            <div class="col col-preorder">{{ order.hasPreorder ? ('getorders.yes' | translate) : ('getorders.no' |
                translate) }}</div>
            <div class="col col-price">{{ order.totalPrice | currency: 'Ft' : 'symbol' : '1.0-0' }}</div>
            <div class="col col-payment">
                @if (order.paymentStatus !== null) {
                <b class="payment-label">{{ getPaymentLabel(order.paymentStatus) }}</b>
                }
                @if (order.paymentOption === 'CASH') {
                <b class="payment-label">{{ 'admin.PAY_ON_STORE' | translate }}</b>
                }
            </div>
            <div class="col col-invoice" (click)="$event.stopPropagation()">
                @if (order.invoiceAvailable) {
                <button type="button" class="btn-icon"
                    (click)="openInvoice(order.orderReference!)"><mat-icon>download</mat-icon></button>
                } @else {
                <button type="button" class="btn-icon" disabled><mat-icon>download</mat-icon></button>
                }
            </div>
            <div class="col col-expand">
                <mat-icon class="expand-indicator">{{ expandedOrderReference === order.orderReference ? 'expand_less' :
                    'expand_more' }}</mat-icon>
            </div>
        </div>

        @if (expandedOrderReference === order.orderReference) {
        <div class="order-detail-panel">
            @if (expandedOrderLoading) {
            <div class="detail-loading">{{ 'getorders.loading' | translate }}</div>
            } @else {
            <pf-order-package-display [inlineMode]="true" [inlineData]="{
                    orderDetails: expandedOrderDetails,
                    deliveryOption: order.deliveryOption,
                    deliveryAddress: expandedOrderDetails[0]?.deliveryAddress,
                    customerAddress: (expandedOrderDetails[0]?.customerZipCode || '') + ' ' + (expandedOrderDetails[0]?.customerSettlement || '') + ' ' + (expandedOrderDetails[0]?.customerAddress || ''),
                    insertedTimestamp: expandedOrderDetails[0]?.insertedTimestamp,
                    packageReference: expandedOrderDetails[0]?.packageReference,
                    separated: order.separated
                }" [inlineInvoiceAvailable]="!!order.invoiceAvailable"
                [inlineShowCreateInvoice]="shouldShowInvoiceButton(order)"
                (statusChanged)="onInlineStatusChanged($event, order)"
                (downloadInvoice)="openInvoice(order.orderReference!)"
                (createInvoice)="loadCreateInvoiceDialog(order.orderReference!)">
            </pf-order-package-display>
            }
        </div>
        }
        }
    </div>

    <div class="mobile-orders">
        @for (order of filteredOrder; track order.orderReference; let i = $index) {
        <div class="mobile-card" [class.mobile-card--unopened]="!order.clerkOpened" tabindex="0">
            <div class="mobile-field">
                <span class="mobile-label">{{ 'getorders.mobile.orderDate' | translate }}</span>
                <span class="mobile-value">{{ order.orderDate | dateUtil }}</span>
            </div>
            <div class="mobile-field">
                <span class="mobile-label">{{ 'getorders.mobile.orderReference' | translate }}</span>
                <span class="mobile-value" style="font-weight: bold">{{ order.orderReference }}</span>
            </div>
            <div class="mobile-field">
                <span class="mobile-label">{{ 'getorders.mobile.name' | translate }}</span>
                <span class="mobile-value">{{ order.name }}</span>
            </div>
            <div class="mobile-field">
                <span class="mobile-label">{{ 'getorders.mobile.email' | translate }}</span>
                <span class="mobile-value">{{ order.email }}</span>
            </div>
            <div class="mobile-field">
                <span class="mobile-label">{{ 'getorders.mobile.totalPrice' | translate }}</span>
                <span class="mobile-value">{{ order.totalPrice | currency: 'Ft' : 'symbol' : '1.0-0' }}</span>
            </div>
            <div class="mobile-field mobile-field--details"
                [class.mobile-field--details-expanded]="expandedOrderReference === order.orderReference"
                (click)="toggleOrderDetails(order); $event.stopPropagation()">
                <span class="mobile-label">{{ 'getorders.details' | translate }}</span>
                <span class="mobile-value">
                    <mat-icon>{{ expandedOrderReference === order.orderReference ? 'expand_less' : 'chevron_right'
                        }}</mat-icon>
                </span>
            </div>
            @if (expandedOrderReference === order.orderReference) {
            <div class="order-detail-panel mobile-detail-panel">
                @if (expandedOrderLoading) {
                <div class="detail-loading">{{ 'getorders.loading' | translate }}</div>
                } @else {
                <pf-order-package-display [inlineMode]="true" [inlineData]="{
                        orderDetails: expandedOrderDetails,
                        deliveryOption: order.deliveryOption,
                        packageReference: expandedOrderDetails[0]?.packageReference,
                        separated: order.separated
                    }" (statusChanged)="onInlineStatusChanged($event, order)">
                </pf-order-package-display>
                }
            </div>
            }
            <div class="mobile-field">
                <span class="mobile-label">{{ 'getorders.mobile.invoice' | translate }}</span>
                <span class="mobile-value">
                    @if (order.invoiceAvailable) {
                    <button type="button" class="btn-icon"
                        (click)="openInvoice(order.orderReference!); $event.stopPropagation()">
                        <mat-icon>download</mat-icon>
                    </button>
                    } @else {
                    <button type="button" class="btn-icon" disabled><mat-icon>download</mat-icon></button>
                    }
                </span>
            </div>
        </div>
        }
    </div>
</div>